export default __webpack_public_path__ + "static/media/achievement_read.a0849aa4.mp3";